<template>
	<div class="page">
		
		<top-header></top-header>
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
					<h3>Manage Orders</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<!--<b-button variant="dark" pill  @click="generateStock()"><b-icon class="mr-2" icon="download" aria-hidden="true"></b-icon>Generate Stock JSON</b-button>-->
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(order_items)="row">
										<b-table :fields="itemfields" :items="row.value" outlined small >
                                            <template v-slot:cell(image_front)="subrow">
                                                <b-img v-bind="thumbnailProps" rounded alt="" :src="$root.MEDIAPATH+$session.get('user_info').uniq_id+'/orders/'+subrow.item.image_front">{{subrow}}</b-img>
                                            </template>
                                            <template v-slot:cell(image_back)="subrow">
                                                <b-img v-bind="thumbnailProps" rounded alt="" :src="$root.MEDIAPATH+$session.get('user_info').uniq_id+'/orders/'+subrow.item.image_back">{{subrow}}</b-img>
                                            </template>
                                        </b-table>
									</template>
                                    <template v-slot:cell(status)="row">
										<b-badge pill variant="warning" v-if="row.value == 0">NEW</b-badge>
										<b-badge pill variant="success" v-else>IN PROCESS</b-badge>
									</template>
                                    <template v-slot:cell(image)="row">
                                        <b-img v-bind="thumbnailProps" rounded alt="" :src="$root.MEDIAPATH+$session.get('user_info').uniq_id+'/stock/img/'+row.item.design_id+'.png'">{{row}}</b-img>
                                    </template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="primary" class="mr-1" @click="showUpdateModal(row.item, row.index, $event.target)" size="sm">View</b-button>
										<!--<b-button pill variant="danger" class="mr-1" @click="showDeleteModal(row.item)" size="sm">Delete</b-button>-->
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

			
			<b-modal id="my-model" title="Order Detail" size="xl" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<form ref="form" @submit.stop.prevent="handleSubmit">
					<b-container fluid>
						<b-row class="mb-1">
                            <b-col cols="6">
                                <b-table-simple hover small caption-top responsive>
                                    <!--<caption></caption>-->
                                    <b-thead head-variant="light">
                                        <b-tr>
                                            <b-th colspan="2">Customer Information</b-th>
                                        </b-tr>
                                    </b-thead>
                                    <b-tbody>
                                        <b-tr>
                                            <b-th>Name</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.name}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Email</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.email}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Phone</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.phone}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Country</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.country}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Postcode</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.postcode}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Sporting Code</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.sportingcode}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Message</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.message}}</b-th>
                                        </b-tr>
                                   </b-tbody>
<!--<b-tfoot><b-tr><b-td colspan="7" variant="secondary" class="text-right"> Total Rows: <b>5</b></b-td></b-tr></b-tfoot>-->
                                </b-table-simple>
                                <!--<b-img class="w-100" rounded alt="" :src="$root.MEDIAPATH+$session.get('user_info').uniq_id+'/stock/img/'+selectedItem.design_id+'.png'"></b-img>-->
                            </b-col>
							<b-col cols="6">
								<b-table-simple hover small caption-top responsive>
                                    <b-thead head-variant="light">
                                        <b-tr>
                                            <b-th colspan="2">Order Information</b-th>
                                        </b-tr>
                                    </b-thead>
                                    <b-tbody>
                                        <b-tr>
                                            <b-th>Date</b-th>
                                            <b-th class="text-right">{{selectedItem.created_at}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Total Items</b-th>
                                            <b-th class="text-right">{{selectedItem.total_items}} Qty</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Price</b-th>
                                            <b-th class="text-right">${{selectedItem.price}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Discount</b-th>
                                            <b-th class="text-right">{{selectedItem.discount}}%</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Status</b-th>
                                            <b-th class="text-right">{{selectedItem.order_status}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Delivery Status</b-th>
                                            <b-th class="text-right">{{selectedItem.delivery_status}}</b-th>
                                        </b-tr>
                                   </b-tbody>
                                </b-table-simple>
							</b-col>
						</b-row>
                        <b-row class="mb-1">
                            <b-col>
                                <b-table :fields="orderfields" :items="selectedItem.order_items" outlined small >
                                    <template v-slot:cell(image_front)="subrow">
                                        <b-img v-bind="regularProps" rounded alt="" :src="$root.MEDIAPATH+$session.get('user_info').uniq_id+'/orders/'+subrow.item.image_front">{{subrow}}</b-img>
									</template>
                                    <template v-slot:cell(image_back)="subrow">
                                        <b-img v-bind="regularProps" rounded alt="" :src="$root.MEDIAPATH+$session.get('user_info').uniq_id+'/orders/'+subrow.item.image_back">{{subrow}}</b-img>
										<br><b-button size="sm" variant="danger" @click="downloadSVG(subrow.item)">Download SVG</b-button>
									</template>
                                    <template v-slot:cell(artwork_data)="row">
										<b-table :fields="artworkfields" :items="convertToArray(row.value)" small >
                                             <template v-slot:cell(color)="colorrow">
												<p v-html="getColorName(colorrow.value)" style="margin-bottom: 0px;"></p>
											</template>
                                        </b-table>
									</template>
									<template v-slot:cell(qty_data)="row">
										<b-table :fields="sizefields" :items="row.value" small >
											<template v-slot:cell(type)="subrow">
												<div v-if="subrow.item.type == 'DETAILS'">{{subrow.item.size}} ({{subrow.item.name}}) ({{subrow.item.number}})</div>
												<div v-if="subrow.item.type == 'QUANTITY'">{{subrow.item.size}}</div>
											</template>
                                        </b-table>
									</template>
                                </b-table>
                            </b-col>
                        </b-row>
					</b-container>
				</form>
				<template v-slot:modal-footer="{ close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
				</template>
			</b-modal>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
	</div>
	
</template>
<script>
import Header from "@/components/Header.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		return{
            loading: true, 
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            regularProps: { blank: false, width: 200, height: 200, class: 'm1' },
            recordUrl: this.$root.WEBAPI+'order-record',
			updateUrl: this.$root.WEBAPI+'order-update',
			deleteUrl: this.$root.WEBAPI+'order-delete',
			artworkUrl: this.$root.WEBAPI+'artwork-load',
			downloadUrl: 'https://phyreapparel.dyobuilders.com/api/create-pdf/pdf/download-pdf.php',
			selectedOrder: '',
			records: [],
			fonts: [],
            category_options: [],
            cut_options: [],
            color_options: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Dyo Designs',
					active: true
				}
			],
			fields: [
				{ key: 'id', label: 'ID'},
				{ key: 'order_items', label: 'Order Detail'},
                { key: 'price', label: 'Price' },
                { key: 'discount', label: 'Discount' },
                { key: 'order_status', label: 'Status' },
                { key: 'payment_status', label: 'Payment' },
				{ key: 'actions', label: 'Actions', 'extra': 1 }
            ],
            itemfields: [
                { key: 'design_id', label: 'Design ID'},
                { key: 'title', label: 'Name'},
                { key: 'image_front', label: 'Front'},
                { key: 'image_back', label: 'Back'}
            ],
            orderfields: [
                { key: 'title', label: 'Name'},
                { key: 'image_front', label: 'Front Image', class: 'text-center'},
                { key: 'image_back', label: 'Back Image', class: 'text-center'},
                { key: 'artwork_data', label: 'Artwork Data'},
				{ key: 'qty_data', label: 'Qty Data'},
                { key: 'qty', label: 'Qty'},
                { key: 'price', label: 'Price'},
            ],
            artworkfields: [
                { key: 'label', label: 'Name'},
                { key: 'color', label: 'Color', class: 'text-right'},
            ],
			sizefields: [
                { key: 'type', label: 'Size'},
                { key: 'value', label: 'Qty', class: 'text-right'},
            ],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {customer_data:{}}
		};
	},
	methods: {
		getColorName(color){
			var selectedcolor = '';
			for(var i = 0; i<this.color_options.length; i++){
				if('#'+this.color_options[i].hexcode == color){
					selectedcolor = this.color_options[i];
					break;
				}
			}
			return '<span style="vertical-align:top">'+selectedcolor.title+"</span><div style='background-color:"+color+"; width:20px; height:20px; display:inline-block; margin-left:10px;'></div>";
		},
        convertToArray(obj){
            var arr = [];
            console.log(obj);
            for (const [key, value] of Object.entries(obj)) {
                //console.log(`${key}: ${value}`);
                console.log(key);
                var o = {};
                o.label = value.label;
                o.color = value.color;
                arr.push(o);
            }
            return arr;
        },
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			this.$root.$emit('bv::show::modal', 'my-model', button)
		},
		showCsvModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to generate product csv!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.csvgenUrl, {
						accesskey: self.$session.get('access_key'),
						product_id: item.product_id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){

							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							
							
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete order!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.design_id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = self.updateUrl;

            
			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('my-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			//var self = this;
			//self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					var _records = response.data.result.records;
					self.fonts = response.data.result.fonts;
					
                    _records.forEach(function(field){
						//console.log('ITES >'+field.order_items+'<');
						if(field.order_items != ""){
							field.order_items = JSON.parse(field.order_items);
							//console.log(JSON.parse(field.order_items)[0].product_id);
						}else{
							field.order_items = [];
						}
						
                        field.customer_data = JSON.parse(field.customer_data);
                    });
                    
                    self.records = _records;
					self.color_options = response.data.result.colors;
					
					self.loading = false;
					self.totalRows = self.records.length;
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
        },
        generateStock(){
            var self = this;
			
			self.axios.post(self.genstockUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		downloadPDF(item){
			console.log(JSON.stringify(item));
			self.axios.post(self.downloadUrl, {
				accesskey: self.$session.get('access_key'),
				artworkid: item.artwork_id
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					console.log(JSON.stringify(response.data.result.artwork));
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		downloadSVG(item){
			var year = String(this.selectedItem.created_at).split("-")[0];
			var tmparr = item.image_front.split("_")[0]
			var design_id = tmparr.split("/")[tmparr.split("/").length-1];
			window.open('https://phyreapparel.dyobuilders.com/download-print.php?order_id='+this.selectedItem.id+'&year='+year+'&design_id='+design_id, "_blank");
			
			/*var self = this;

			let parser = new DOMParser()
			let svgdom = parser.parseFromString(atob(item.print_data), "image/svg+xml");

			var svgroot = svgdom.getElementsByTagName("svg")[0];

			var script = document.createElement('style');
			script.setAttribute('type', 'text/css');
			
			var fontarray = [];
			item.canvas_data.objects.forEach(el => {
				if(el.type == 'text'){
					if(fontarray.indexOf(el.fontFamily) == -1){
						fontarray.push(el.fontFamily);
						//break;
					}
				}
			});
			self.fonts.forEach(fnt => {
				if(fontarray.indexOf(fnt.fontfamily) > -1){
					script.appendChild( document.createTextNode(fnt.svgfont) );
				}
			});
			svgroot.appendChild(script);

			//svgroot.setAttribute('width', item.canvas_data.attrs.width);
			//svgroot.setAttribute('height', item.canvas_data.attrs.height);
			

			//svgroot.setAttributeNS(null, 'width', item.canvas_data.attrs.width);
			//svgroot.setAttributeNS(null, 'height', item.canvas_data.attrs.height);

			
			
			//console.log(new XMLSerializer().serializeToString(svgdom));

			var dataURL = "data:image/svg+xml;charset=utf-8,"+encodeURIComponent(new XMLSerializer().serializeToString(svgdom));

			var dl = document.createElement("a");
			document.body.appendChild(dl); 
			dl.setAttribute("href", dataURL);
			dl.setAttribute("download", item.id+".svg");
			dl.click();
			
			*/
        },
	}
}
</script>
<style>
</style>